module.exports = __webpack_public_path__ + "static/media/spinner.984381ca.gif";